<div class="job-referral-link-dialog-overlay" *ngIf="isOpen" (click)="closeDialog()">
  <div class="job-referral-link-dialog" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h4 class="dialog-title">Link de indicação</h4>
      <button type="button" class="close-btn" (click)="closeDialog()" aria-label="Fechar">×</button>
    </div>

    <div class="dialog-content">
      <p class="dialog-description">
        <ng-container *ngIf="jobTitle">
          Utilize esse link para indicar alguém especificamente para a vaga de
          <span class="job-title">{{ jobTitle }}</span>.
        </ng-container>
        <ng-container *ngIf="!jobTitle">
          Utilize esse link para indicar alguém para a vaga.
        </ng-container>
      </p>

      <div class="form-group">
        <label class="form-label" for="referralLink">Link</label>
        <input
          type="text"
          id="referralLink"
          class="form-control"
          [value]="displayLink"
          readonly
          (click)="selectAllText($event)">
      </div>
    </div>

    <div class="dialog-footer">
      <button type="button" class="btn btn-close-dialog" (click)="closeDialog()">
        Fechar
      </button>
      <button type="button" class="btn btn-copy" (click)="copyLink()" [class.copied]="isCopied">
        <span *ngIf="!isCopied">Copiar</span>
        <span *ngIf="isCopied">✓ Link copiado com sucesso!</span>
      </button>
    </div>
  </div>
</div>
